module.exports = __webpack_public_path__ + "img/gupiao1.3bacb58d.png";